import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Registration} from '../../../model/user/registration';
import {RegistrationService} from '../../../services/registration.service';
import {AppState} from '../../../store/app.states';
import {Store} from '@ngrx/store';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {DateAdapter, MatOptionSelectionChange} from '@angular/material/core';
import {PingService} from '../../../services/ping.service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css'],
})

export class RegistrationComponent implements OnInit {

  registrationForm: FormGroup;
  notFocused = false;
  registrationBody: Registration;
  submitted: boolean;
  show = false;
  birthDate: string;
  title = 'IBD Tool';
  doctorRoles = ['SENIOR', 'JUNIOR'];

  constructor(private registrationService: RegistrationService,
              private store: Store<AppState>,
              private dateAdapter: DateAdapter<Date>,
              private pingService: PingService) {
    this.dateAdapter.setLocale('it');
  }

  ngOnInit(): void {
    this.pingService.ping();
    this.registrationForm = new FormGroup({
      email: new FormControl('', [Validators.required, this.myValidatorEmail]),
      name: new FormControl('', [Validators.required]),
      surname: new FormControl('', [Validators.required]),
      ssn: new FormControl('', [Validators.required,this.myValidatorSSN]),
      phoneNumber: new FormControl('', [Validators.required]),
      // birthPlace: new FormControl('', [Validators.required]),
      // province: new FormControl('', [Validators.required]),
      // cap: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
      doctorRole: new FormControl('', [Validators.required])
    });
  }

  myValidatorEmail(control: FormControl) {
    if(control.value.includes("@") && control.value.includes(".")) 
      return null;
      else return {required: true}
   }

   myValidatorSSN(control: FormControl) {
     //deve rispettare il seguente formato
    var pattern = /^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/;
    if (control.value.search(pattern) == -1)
    {
      // In caso di errore 
      return {required: true}
    }else{
       // ...in caso contrario ok
       return null
    }
   }

  onSubmit(registration) {
    this.submitted = true;
    this.show = true;
    console.log(registration);
    const val = registration;
    var newMail = val.email.replace(/\s/g, "");
    var newSSN = val.ssn.replace(/\s/g, "");

    // tslint:disable-next-line:max-line-length
    this.registrationBody = new Registration(
      newMail,
      val.name,
      val.surname,
      newSSN,
      this.birthDate,
      '',
      val.phoneNumber,
      val.password,
      val.doctorRole
    );

    this.registrationService.register(this.registrationBody);
  }

  setDate($event: MatDatepickerInputEvent<any>) {
    this.birthDate =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10);

    console.log(this.birthDate);
  }

  selectResult($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      this.registrationForm.get('doctorRole').setValue(value);
      console.log(this.registrationForm.get('doctorRole').value);
    }
  }

}
